import React from "react"
import styled from "styled-components"

import IconWithText, { IconWithTextContainer } from "./IconWithText"

import { media } from "../styles"

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  @media ${media.md} {
    flex-flow: row wrap;
    justify-content: flex-start;
  }

  ${IconWithTextContainer} {
    @media ${media.md} {
      width: 50%;
    }

    @media ${media.lg} {
      width: 33.33333%;
    }
  }
`

const IconWithTextGrid = ({ items, className, layout }) => {
  return (
    <Grid className={className}>
      {items.map((item, i) => (
        <IconWithText
          key={i}
          title={item.title}
          text={item.description?.childMarkdownRemark?.html || item.description}
          icon={item.icon}
          layout={layout}
        />
      ))}
    </Grid>
  )
}

export default IconWithTextGrid
